import { CalendarViewMode } from "./calendar-settings";
import { ICalendarAppText } from "./text/calendar-app.text";
import { IFilterText } from "./text/calendar-filter.text";
import { IMiniCalendarText } from "./text/mini-calendar.text";
import { ITaggingText } from "./text/tagging.text";

/**
 * Combined type containing all the CMS text needed throughout the Calendar app.
 */
export type CalendarAppText = ICalendarAppText & IFilterText & IMiniCalendarText & ITaggingText;

export const defaultText: CalendarAppText = {
    // ICalendarAppText
    calendarAppHeading: "Calendar",
    listViewHeading: "Calendar Events List",
    emptyMonthMessage: 'There are no events',
    emptyDayMessage: 'There are no events',
    loadMoreEventsButtonText: 'Load More',
    applyPromoCodeButtonText: 'Apply Code',
    defaultToListView: false,
    noEventsString: "No events.",
    noEventsThroughFiltersString: "No events based on your preferences.",
    singleEventText: "event",
    pluralEventsText: "events",
    fallbackThumbnailImageSrc: "",
    promoCodeDescriptionText: "Enter promo code",
    apiError: null,
    calendarLoadingLabel: "Calendar is loading",
    calendarDoneLoadingLabel: "Calendar has loaded",
    todayText: "Today",
    dateFormat: "ddd. MMM. D, YYYY",
    timeFormat: "ha",
    timeFormatNoMinutes: "h:mma",
    accessibleMonthFormat: "MMMM YYYY",
    monthDropdownDescriptionText: "Select Month",
    viewMoreDatesButtonText: "View More",
    showLessDatesButtonText: "Show Less",
    eventFilterDefault:"All",
    // IFilterText
    productionFilterLabelText: "",
    productionSelectAllDropdownOption: "All Productions",
    calendarFiltersHeading: "Calendar Filters",
    calendarFiltersBackground: "default",
    filterOpenButtonText: "Filters",
    filterOpenButtonLabel: "Open the filters dialog",
    filterTriggerButtonText: "Done",
    filterTriggerButtonLabel: "Apply the selected filters and close the filters dialog",
    filterCloseButtonText: "Cancel",
    filterCloseButtonLabel: "Close the filter dialog without applying changes to the filters",
    typeFilterTitleText: "Type",
    typeAllSelectionText: "All",
    venueSelectAllDropdownOption: "All Venues",
    accessibilityFilterTitleText: "Accessibility",
    accessibilityAllSelectionText: "All",
    dateAndTimeFilterTitleText: "Date & Time",
    discountFilterTitleText: "Discount",
    discountAllSelectionText: "All",
    nothingSelectedText: "Nothing selected.",
    clearAllButtonText: "Clear All",
    clearAllButtonLabel: "Remove all applied filters",
    //IMiniCalendarText
    miniCalendarHiddenHeading: "Calendar Date Navigation",
    skipToEventsButtonText: "Skip to events list",
    keyboardInstructions: "Use the arrow keys to navigate between days of the month. Use shift + up/down arrows to navigate between months.",
    previousMonthButtonText: "Previous month",
    nextMonthButtonText: "Next month",
    dateAvailabilityDescription: "{COUNT} {DESCRIPTION}",
    noAvailabilityDescription: "No events found",
    limitedAvailabilityDescription: "Selected filters may limit date availability.",
    monthFormat: "MMM. YYYY",
    audioDescribedTooltip: "Audio Described",
    audioDescribedLabel: "Audio Described",
    openCaptionedTooltip: "Open Captioning",
    openCaptionedLabel: "Open Captioning",
    sensoryFriendlyTooltip: "Sensory Friendly",
    sensoryFriendlyLabel: "Sensory Friendly",
    signInterpretedTooltip: "Sign Interpreted",
    signInterpretedLabel: "Sign Interpreted",
    cuedSpeechTooltip: "Cued Speech",
    cuedSpeechLabel: "Cued Speech",
    bravoLabel: "Bravo",
    myTixLabel: "MyTix",
    studentRushLabel: "Student Rush",
    notOnSale: "Not On Sale",
    loaderImageUrl: "",
    gridViewHeading: "Calendar Grid",
    gridViewModeButtonText: 'Grid View',
    listViewModeButtonText: 'List View',
    emptyMonthMessaging:""
}